import { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { handleOAuthCallback, waitForUserAuth, sanitizeReturnTo } from "./utils/AuthService";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import { setFirstLoad } from "./store/redux/actions/userActionCreator";
import { BrandLoader } from "./components/ui/BrandLoader";

const Callback = ({ t, ...props }: any) => {
    const navigate = useNavigate();
    const isHandlingCallback = useRef(false);
    const [isProcessing, setIsProcessing] = useState(false);

    useEffect(() => {
        const handleCallback = async () => {
            if (!isHandlingCallback.current && !isProcessing) {
                isHandlingCallback.current = true;
                setIsProcessing(true);
                try {
                    // signinCallback completes the code exchange, writes the
                    // user to the OIDC store, and fires addUserLoaded — which
                    // authLifecycle.ts turns into a SET_USER_AUTH_INFO
                    // dispatch. We don't dispatch it here.
                    const user = await handleOAuthCallback(window.location.href);

                    const returnTo = sanitizeReturnTo(user?.state && (user.state as any).returnTo);

                    // Defensive: wait for the user to be readable from storage
                    // before navigating (addUserLoaded may not have flushed).
                    await waitForUserAuth(4000, 50);
                    props.setFirstLoad(true);
                    navigate(returnTo);
                } catch (error) {
                    console.error("Error handling OAuth callback:", error);
                    navigate("/");
                } finally {
                    setIsProcessing(false);
                    isHandlingCallback.current = false;
                }
            }
        };

        if (window.location.search && !isProcessing) {
            handleCallback();
        }
    }, []);

    // The first thing a user sees after authenticating. Named, because unlike
    // the boot splash this wait has a specific subject.
    return <BrandLoader label={t('Signing you in...')} />;
};

const mapStateToProps = (_state: any) => ({});

const mapDispatchToProps = (dispatch: any) => ({
    setFirstLoad: (firstLoad: boolean) => dispatch(setFirstLoad(firstLoad))
});

export default (connect(mapStateToProps, mapDispatchToProps))(withTranslation()(Callback));
